import rootStores from "@/Stores/RootStores";

export const useCatalogShowMore = () => {
    const {catalogStore} = rootStores;

    const hasMore = catalogStore.activePage < Math.ceil(catalogStore.catalogCount / catalogStore.perPageStart);

    return {
        hasMore,
        loading: catalogStore.loaderShowBtn,
        showMore: catalogStore.showMore,
    };
};
